import React from 'react';
import { CAP, IND, RES } from '../PCBHelper';
import { N_PORT, SHUNT_L, SHUNT_R, SHUNT_C, VC_RLC_TYPES } from './virtualCompHelper';
import { checkRLCValueFormat } from '../helper/dataProcess';
import { CUSTOM_SPICE, CUSTOM_TOUCHSTONE } from '../../constants/libraryConstants';
import { SIERRA } from '../../constants/pageType';

function getVirtualCompsErrors(virtualComps, checkInfo) {
  const { touchstoneList = [], spiceList = [], getCheckFile, pcbName = null, product = null } = checkInfo || {};


  let errors = [];
  for (let comp of virtualComps || []) {

    if (!comp.pins || !comp.pins.length) {
      errors.push(<p style={{ margin: 0 }}>Virtual Component "<span className="font-bold">{pcbName ? `${pcbName}::${comp.name}` : comp.name}</span>" does not have any pins.</p>)
    }

    if (VC_RLC_TYPES.includes(comp.type)) {
      errors = resValueCheck(comp, errors, pcbName, product);
    } else if (comp.type === N_PORT) {
      errors = nPortModelCheck({ comp, errors, touchstoneList, spiceList, getCheckFile, pcbName });
    }

    errors = pinsLocationCheck(comp, errors, pcbName);
  }
  return errors.length ? errors : []
}


function getValueTitle(type) {
  switch (type) {
    case RES:
    case SHUNT_R:
    case "r":
      return "resistance";
    case IND:
    case SHUNT_L:
    case "l":
      return "inductance";
    case CAP:
    case SHUNT_C:
    case "c":
      return "capacitance";
    default: return "";
  }
}

function resValueCheck(comp, errors, pcbName, product) {
  const title = getValueTitle(comp.type);
  if (!comp.value) {
    errors.push(<p style={{ margin: 0 }}>Virtual Component "<span className="font-bold">{pcbName ? `${pcbName}::${comp.name}` : comp.name}</span>" does not set {title} value.</p>);
    return errors;
  }

  if ([CAP, SHUNT_C].includes(comp.type) && product === SIERRA) {
    if (!comp.value) {
      errors.push(<p style={{ margin: 0 }}>Virtual Component "<span className="font-bold">{pcbName ? `${pcbName}::${comp.name}` : comp.name}</span>" does not set RLC value.</p>);
      return errors;
    }

    if (typeof comp.value === "string") {
      const valueCheck = checkRLCValueFormat(comp.value);
      if (!valueCheck) {
        errors.push(<p style={{ margin: 0 }}>Virtual Component "<span className="font-bold">{pcbName ? `${pcbName}::${comp.name}` : comp.name}</span>" capacitance value format error.</p>);
      }
    } else {
      for (let key of ["r", "l", "c"]) {
        const _title = getValueTitle(key);
        if (!comp.value[key] && parseFloat(comp.value[key]) !== "0") {
          errors.push(<p style={{ margin: 0 }}>Virtual Component "<span className="font-bold">{pcbName ? `${pcbName}::${comp.name}` : comp.name}</span>" does not set {_title} value.</p>);
          break;
        }
        const valueCheck = checkRLCValueFormat(comp.value[key]);
        if (!valueCheck) {
          errors.push(<p style={{ margin: 0 }}>Virtual Component "<span className="font-bold">{pcbName ? `${pcbName}::${comp.name}` : comp.name}</span>" {_title} value format error.</p>);
          break;
        }
      }
    }
  } else {
    const resCheck = checkRLCValueFormat(comp.value);
    if (!resCheck) {
      errors.push(<p style={{ margin: 0 }}>Virtual Component "<span className="font-bold">{pcbName ? `${pcbName}::${comp.name}` : comp.name}</span>" {title} value format error.</p>);
    }
  }

  return errors;
}

function nPortModelCheck({ comp, errors, touchstoneList, spiceList, getCheckFile, pcbName }) {
  if (!comp.files || !comp.files.length) {
    errors.push(<p style={{ margin: 0 }}>Virtual Component "<span className="font-bold">{pcbName ? `${pcbName}::${comp.name}` : comp.name}</span>" does not set model.</p>);
    return errors;
  } else {
    for (let file of comp.files) {
      const fileType = file.type === 'Touchstone' ? CUSTOM_TOUCHSTONE : CUSTOM_SPICE;
      const fileExist = getCheckFile ? getCheckFile(fileType, file.libraryId) : getFileExist(file, touchstoneList, spiceList);
      if (!fileExist) {
        errors.push(<p style={{ margin: 0 }}>Virtual Component "<span className="font-bold">{pcbName ? `${pcbName}::${comp.name}` : comp.name}</span>" {file.type || ""} file {file.fileName} not exist.</p>);
      }
    }
  }

  for (let pin of comp.pins || []) {
    if (!pin.node || !pin.libraryId || !pin.modelKey) {
      errors.push(<p style={{ margin: 0 }}>Virtual Component "<span className="font-bold">{pcbName ? `${pcbName}::${comp.name}` : comp.name}::{pin.pin}</span>" does not set node.</p>);
    }
  }
  return errors;
}

function getFileExist(file, touchstoneList, spiceList) {
  let list = file.type === 'Touchstone' ? touchstoneList : (file.type === 'SPICE' ? spiceList : []);
  const find = (list || []).find(item => item.id === file.libraryId);
  if (!find) {
    return false;
  }
  return true;
}

function pinsLocationCheck(comp, errors, pcbName) {
  for (let pin of comp.pins || []) {
    if (!pin.location || pin.location.length !== 2) {
      errors.push(<p style={{ margin: 0 }}>Virtual Component "<span className="font-bold">{pcbName ? `${pcbName}::${comp.name}` : comp.name}::{pin.pin}</span>" location calculate error.</p>);
    }
  }
  return errors;
}

export {
  getVirtualCompsErrors
}